/* eslint-disable @typescript-eslint/no-explicit-any */
import DOMPurify from 'isomorphic-dompurify';

/**
 * Safely serializes data for embedding in a <script> tag by escaping
 * HTML-sensitive characters as unicode escapes to prevent XSS.
 */
export const safeJsonLdStringify = (data: unknown): string => {
  return JSON.stringify(data).replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/&/g, '\\u0026');
};

export const stripHtmlToPlainText = (html: string): string => {
  if (!html || typeof html !== 'string') {
    return '';
  }
  const sanitizedFragment = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [],
    ALLOWED_ATTR: [],
    RETURN_DOM_FRAGMENT: true,
  }) as DocumentFragment;

  return (sanitizedFragment.textContent ?? '')
    .replace(/\r\n|\r|\n/g, ' ') // replace line breaks with space
    .replace(/\s+/g, ' ') // collapse multiple spaces
    .trim();
};

export const constructFAQJsonSchema = (data: any, item: any) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return;
  }
  const headerListItems = data;
  const richTextItems = item ?? {};
  const faqsArray: any = headerListItems.map((headerItem: any) => {
    const nodeName = headerItem?.nodeName ?? '';
    const name = headerItem?.header ?? '';
    const specificCard = richTextItems?.[nodeName] ?? {};
    const items = specificCard?.[':items'] ?? {};
    const richtextKey = Object.keys(items).find(key => key.startsWith('richtext'));
    const text = items[richtextKey ?? '']?.text ?? items?.text?.descriptionText ?? '';
    const nameRTEText = stripHtmlToPlainText(name);
    const textRTE = stripHtmlToPlainText(text);
    return {
      '@type': 'Question',
      name: nameRTEText,
      acceptedAnswer: {
        '@type': 'Answer',
        text: textRTE,
      },
    };
  });

  const jsonObject = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    name: 'Marriott Offers Frequently Asked Questions',
    mainEntity: faqsArray,
  };

  return jsonObject;
};
